Pixlee.module('Tap2ShopApp', function(Tap2ShopApp, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    Tap2ShopApp.on("start", function(options) {
        new Tap2ShopApp.Show.Controller(options);
    });
});